import { useGSAP } from "@gsap/react";
import { Box } from "@mui/material";
import gsap from "gsap";
import isMobile from "is-mobile";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import useSound from "use-sound";

import wheelSfx from "../../../assets/sfxs/Roulettte/wheel.mp3";

import { RouletteBetStatus } from "../../../constants/enum/roulette";

import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import useWallet from "../../../hook/useWallet";

import { startRouletteAnimation } from "./helper/animation";
import useStyles from "./wheel.styles";

gsap.registerPlugin(useGSAP);

const initialAngle = 360 / 38 / 2;

const RouletteBoardSize = {
  small: {
    wheel: 250,
    ball: 10,
    offset: {
      start: 100,
      end: 72,
    },
  },

  medium: {
    wheel: 320,
    ball: 12,
    offset: {
      start: 105,
      end: 72,
    },
  },

  big: {
    wheel: 400,
    ball: 14,
    offset: { start: 160, end: 105 },
  },
};

const RouletteWheel = () => {
  const dispatch = useAppDispatch();
  const { classes } = useStyles();
  const { account } = useWallet();
  const { betResult, betStatus } = useAppSelector((state) => state.roulette);
  const { id } = useParams();

  const boardSize = isMobile()
    ? RouletteBoardSize.medium
    : RouletteBoardSize.big;

  const [ballContainerAngle, setBallContainerAngle] = useState(initialAngle);
  const [ballOffsetY, setBallOffsetY] = useState(boardSize.offset.start);

  const [playWheelSfx] = useSound(wheelSfx, {
    loop: false,
    volume: 1,
  });

  useEffect(() => {
    if (!betResult) return;

    startRouletteAnimation(
      betResult.nonce,
      boardSize,
      playWheelSfx,
      setBallContainerAngle,
      setBallOffsetY,
      dispatch,
      account,
      Number(id)
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account, betResult]);

  return (
    <Box className={classes.wheelBox}>
      <Box
        className={classes.wheelContainer}
        sx={{
          height: boardSize.wheel,
        }}
      >
        <Box
          className={classes.rouletteWheel}
          sx={{
            width: boardSize.wheel,
            height: boardSize.wheel,
          }}
        >
          <Box className={classes.rouletteInner}>
            {betStatus === RouletteBetStatus.SPINNING && (
              <Box
                className={classes.ballContainer}
                sx={{
                  transform: `rotate(${ballContainerAngle}deg) translateY(${
                    boardSize.wheel / 2 - boardSize.ball / 2
                  }px) translateX(${
                    boardSize.wheel / 2 - boardSize.ball / 2
                  }px)`,
                  width: boardSize.ball,
                  height: boardSize.ball,
                  transformOrigin: `${boardSize.wheel / 2}px ${
                    boardSize.wheel / 2
                  }px`,
                }}
              >
                <Box
                  className={classes.ball}
                  sx={{
                    transform: `translate(0, ${ballOffsetY}px)`,
                    width: boardSize.ball,
                    height: boardSize.ball,
                  }}
                ></Box>
              </Box>
            )}

            <svg width={boardSize.wheel} height={boardSize.wheel}>
              <circle
                cx={boardSize.wheel / 2}
                cy={boardSize.wheel / 2}
                r={boardSize.wheel / 2}
                style={{ touchAction: "none" }}
              ></circle>
            </svg>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default RouletteWheel;
